import React from 'react'
import { array, bool, string, object } from 'prop-types'

// components
import { CardBusinessListing } from '../CardBusinessListing'
import { CardForContentSummary } from '../CardForContentSummary'

import { isBrowser, makeImgResizerUrl } from '@jelly/utils'

const CardPropTypes = {
	result: object.isRequired,
	showContentDescription: bool,
}

const SponsoredAds = ({ result }) => {
	return (
		<CardBusinessListing
			headline={result.dek}
			thumbnail={
				result.thumbnail
					? makeImgResizerUrl({
							src: result.thumbnail,
							method: 'r',
							w: 100,
							h: 100,
					  })
					: ''
			}
			title={result.title}
			url={result.canonical}
		/>
	)
}
SponsoredAds.propTypes = CardPropTypes

const ContentSummary = ({ result, showContentDescription }) => {
	const {
		author,
		canonical,
		description,
		doc_type,
		modified_at,
		sponsored,
		subtitle,
		thumbnail,
		title,
		total_answers,
	} = result
	return (
		<CardForContentSummary
			author={author}
			blurb={showContentDescription ? description : null}
			displayModified={modified_at}
			docType={doc_type}
			key={title}
			outerUrl={canonical}
			isSponsored={sponsored}
			subtitle={subtitle}
			thumbnail={makeImgResizerUrl({
				src: thumbnail.path,
				method: doc_type === 'review' ? 'r' : 'rc',
				w: 100,
				h: 75,
			})}
			title={title}
			total_answers={total_answers}
		></CardForContentSummary>
	)
}
ContentSummary.propTypes = CardPropTypes

ResultsList.propTypes = {
	searchTerm: string,
	showAdUnit: bool,
	showContentDescription: bool,
	showSponsoredAds: bool,
	results: array,
}

export function ResultsList({
	results = [],
	searchTerm = '',
	showAdUnit = true,
	showContentDescription = true,
	showSponsoredAds = true,
}) {
	return (
		<>
			{!!results.length &&
				results.map((result, index) => {
					switch (result.doc_type) {
						case 'adunit':
							if (isBrowser()) {
								window.googletag &&
									window.googletag.apiReady &&
									window.googletag.pubads().setTargeting('search_term', searchTerm).refresh()
							}
							return (
								showAdUnit && (
									<div id="in-article-vca-1" className="ad-unit" key={`${result.guid}${index}`} />
								)
							)
						case 'business_listing':
						case 'featured_listing':
							return showSponsoredAds && <SponsoredAds key={`${result.guid}${index}`} result={result} />
						case 'article':
						case 'category':
						case 'infographic':
						case 'review':
						case 'user':
						case 'video':
						case 'whitepaper':
							return (
								<ContentSummary
									key={`${result.guid}${index}`}
									result={result}
									showContentDescription={showContentDescription}
								/>
							)
						case 'qtWidget':
							return result.qtWidget
						default:
							return null
					}
				})}
		</>
	)
}
